import { config } from '../config';
import { authService } from './auth';

async function authHeaders(): Promise<Record<string, string>> {
  const token = await authService.getIdToken();
  return { Authorization: token ?? '', 'Content-Type': 'application/json' };
}

export interface AccountLimits {
  maxQrs: number | null;
  maxPages: number | null;
  scanBurstPerMinute: number;
  monthlyScans: number | null;
}

export interface AccountUsage {
  qrCount: number;
  pageCount: number;
  monthlyScans: number;
}

export interface AccountInfo {
  tier: 'free' | 'pro';
  limits: AccountLimits;
  usage: AccountUsage;
}

export async function getAccount(): Promise<AccountInfo> {
  const res = await fetch(`${config.apiUrl}/account`, { headers: await authHeaders() });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error ?? `Request failed: ${res.status}`);
  return data as AccountInfo;
}
